import React, { useState, useEffect, useLayoutEffect } from "react";

// ui
import {
  Button,
  Typography,
  Modal,
  Box,
  Paper,
  FormControl,
  TextField,
  FormHelperText,
  Select,
  MenuItem,
  Checkbox,
  InputLabel,
  Autocomplete,
} from "@mui/material";
import { styled } from "@mui/system";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import RemoveCircleOutlineIcon from "@mui/icons-material/RemoveCircleOutline";
// InterFace
import { DataColumn, SubDataColumn } from "../config/dataInterface";
import { LIST_POST } from "../config/const";
// jotai
import { useAtomValue } from "jotai";
import { AppAtoms } from "../lib/store";
import { useWindowSize } from "../lib/useWindowSize";

const CustomTextField = styled(TextField)({
  "& .MuiInputBase-input": {
    fontSize: "12px",
    height: "12px", // ここでフォントサイズを指定
  },
});
CustomTextField.defaultProps = {
  autoComplete: "off",
};
function SerchInputField({
  disabled,
  inputList,
  inputListKey,
  helperText,
  label,
  marginLeft,
  width,
  value,
  setAddData,
  dataKey,
  addData,
}: {
  disabled: boolean;
  inputList: {
    id: number;
    [key: string]: string | number;
  }[];
  inputListKey: string;
  label: string;
  helperText: string;
  marginLeft: string;
  width: string;
  value: string;
  setAddData: React.Dispatch<
    React.SetStateAction<{ [key: string]: string | boolean | any[] }>
  >;
  dataKey: string;
  addData: { [key: string]: string | boolean | any[] };
}) {
  const autocompleteInputList: string[] = inputList.map((input) => {
    return input[inputListKey] as string;
  });
  return (
    <FormControl
      fullWidth
      sx={{
        marginTop: "10px",
        marginBottom: "20px",
        marginLeft,
        width,
      }}
    >
      <InputLabel id="serch-input-label">{label}</InputLabel>
      <Autocomplete
        disabled={
          (dataKey === "unique_payment_name" ||
            dataKey === "service_toss_up_company_id") &&
          Number(addData["trading_type"]) !== 1 &&
          Number(addData["trading_type"]) !== 3
            ? true
            : dataKey === "entry_sale_company_group" &&
                Number(addData["entry_sale_company_id"]) === 0
              ? true
              : dataKey === "login_sale_company" &&
                  Number(addData["screen_column_auth"]) === 1
                ? true
                : disabled
        }
        clearIcon={null}
        options={autocompleteInputList}
        value={value}
        onChange={(event: any, newValue: string | null) => {
          if (newValue) {
            const targetValue = newValue;
            let targetID: null | number = null;
            inputList.map((input) => {
              if (input[inputListKey] === targetValue) {
                targetID = input.id as number;
              }
            });
            if (targetID !== null) {
              if (
                dataKey === "authority" &&
                (targetID === 0 || targetID === 1)
              ) {
                setAddData((addData) => ({
                  ...addData,
                  sale_company_id: "",
                  sale_company_id_name: "",
                  sale_company_group_id: "",
                  sale_company_group_name: "",
                  [dataKey]: targetID!.toString(),
                  [dataKey + "_name"]: targetValue,
                }));
              } else if (dataKey === "authority" && targetID === 2) {
                setAddData((addData) => ({
                  ...addData,
                  sale_company_group_id: "",
                  sale_company_group_name: "",
                  [dataKey]: targetID!.toString(),
                  [dataKey + "_name"]: targetValue,
                }));
              } else if (dataKey === "product_key" && targetID === 1) {
                setAddData((addData) => ({
                  ...addData,
                  product_contract_number: "",
                  [dataKey]: targetID!.toString(),
                  [dataKey + "_name"]: targetValue,
                }));
              } else if (dataKey === "sns_type" && targetID === 2) {
                setAddData((addData) => ({
                  ...addData,
                  sns_id: "",
                  sns_toss_up_account_info: "",
                  sns_haeder: "",
                  sns_footer: "",
                  [dataKey]: targetID!.toString(),
                  [dataKey + "_name"]: targetValue,
                }));
              } else if (dataKey === "cancell_sns_type" && targetID === 2) {
                setAddData((addData) => ({
                  ...addData,
                  cancell_sns_id: "",
                  cancell_sns_haeder: "",
                  cancell_sns_footer: "",
                  [dataKey]: targetID!.toString(),
                  [dataKey + "_name"]: targetValue,
                }));
              } else if (dataKey === "trading_type" && targetID === 0) {
                setAddData((addData) => ({
                  ...addData,
                  service_toss_up_company_id: "",
                  unique_payment_name: "",
                  back_payment_time: "",
                  back_payment_time_name: "",
                  [dataKey]: targetID!.toString(),
                  [dataKey + "_name"]: targetValue,
                }));
              } else if (dataKey === "trading_type" && targetID === 1) {
                setAddData((addData) => ({
                  ...addData,
                  back_payment_time: "",
                  back_payment_time_name: "",
                  [dataKey]: targetID!.toString(),
                  [dataKey + "_name"]: targetValue,
                }));
              } else if (dataKey === "trading_type" && targetID === 2) {
                setAddData((addData) => ({
                  ...addData,
                  service_toss_up_company_id: "",
                  unique_payment_name: "",
                  [dataKey]: targetID!.toString(),
                  [dataKey + "_name"]: targetValue,
                }));
              } else if (dataKey === "trading_type" && targetID === 3) {
                setAddData((addData) => ({
                  ...addData,
                  [dataKey]: targetID!.toString(),
                  [dataKey + "_name"]: targetValue,
                }));
              } else if (
                dataKey === "incentive_status_conf" &&
                targetID === 0
              ) {
                setAddData((addData) => ({
                  ...addData,
                  incentive_status: "",
                  [dataKey]: targetID!.toString(),
                  [dataKey + "_name"]: targetValue,
                }));
              } else if (
                dataKey === "follow_call_entry_status_conf" &&
                targetID === 0
              ) {
                setAddData((addData) => ({
                  ...addData,
                  follow_call_entry_status: "",
                  [dataKey]: targetID!.toString(),
                  [dataKey + "_name"]: targetValue,
                }));
              } else if (dataKey === "outside_sms_type") {
                setAddData((addData) => ({
                  ...addData,
                  outside_sms_title: "",
                  [dataKey]: targetID!.toString(),
                  [dataKey + "_name"]: targetValue,
                }));
              } else if (dataKey === "cancell_sms_type") {
                setAddData((addData) => ({
                  ...addData,
                  cancell_sms_title: "",
                  [dataKey]: targetID!.toString(),
                  [dataKey + "_name"]: targetValue,
                }));
              } else {
                setAddData((addData) => ({
                  ...addData,
                  [dataKey]: targetID!.toString(),
                  [dataKey + "_name"]: targetValue,
                }));
              }
            }
          }
        }}
        renderInput={(params) => (
          <TextField
            value={value}
            sx={{
              "& .MuiInputBase-root": {
                fontSize: "12px",
                height: "32px", // ここでフォントサイズを指定
              },
            }}
            {...params}
          />
        )}
      />
      <FormHelperText
        id="serch-name"
        sx={{
          textAlign: "right",
          minHeight: "25px",
          whiteSpace: "pre-line",
        }}
      >
        {helperText}
      </FormHelperText>
    </FormControl>
  );
}
function SerchTextField({
  disable,
  width,
  label,
  helperText,
  value,
  setValue,
  dataKey,
  addData,
  multiline,
}: {
  disable: boolean;
  width: string;
  label: string;
  helperText: string;
  value: string;
  setValue: (value: string) => void;
  dataKey: string;
  addData: { [key: string]: string | boolean | any[] };
  multiline: boolean;
}) {
  const textFieldMargin = "10px 5px ";
  return (
    <Box>
      <Box className="serch-label">{label}</Box>
      <CustomTextField
        disabled={
          (dataKey === "sns_id" ||
            dataKey === "sns_toss_up_account_info" ||
            dataKey === "sns_haeder" ||
            dataKey === "sns_footer") &&
          Number(addData["sns_type"]) == 2
            ? true
            : (dataKey === "cancell_sns_id" ||
                  dataKey === "cancell_sns_haeder" ||
                  dataKey === "cancell_sns_footer") &&
                Number(addData["cancell_sns_type"]) == 2
              ? true
              : dataKey === "unique_payment_name" &&
                  Number(addData["trading_type"]) !== 1 &&
                  Number(addData["trading_type"]) !== 3
                ? true
                : dataKey === "incentive_status" &&
                    Number(addData["incentive_status_conf"]) !== 1
                  ? true
                  : dataKey === "follow_call_entry_status" &&
                      Number(addData["follow_call_entry_status_conf"]) !== 1
                    ? true
                    : dataKey === "outside_sms_title" &&
                        Number(addData["outside_sms_type"]) !== 1
                      ? true
                      : dataKey === "cancell_sms_title" &&
                          Number(addData["cancell_sms_type"]) !== 1
                        ? true
                        : dataKey === "outside_cancell_form_text" &&
                            Number(addData["outside_cancell_form"]) !== 1
                          ? true
                          : dataKey === "outside_cancell_form_mail_address" &&
                              Number(addData["outside_cancell_form"]) !== 1
                            ? true
                            : disable
        }
        type={dataKey !== "password" ? "text" : "password"}
        id="textFieldId"
        value={value}
        size="small"
        onChange={(e) => setValue(e.target.value)}
        sx={{ width, margin: textFieldMargin }}
        multiline={multiline}
        rows={multiline ? 4 : undefined}
      />
      <FormHelperText
        id="serch-name"
        sx={{
          width,
          textAlign: "right",
          marginTop: "-8px",
          minHeight: "25px",
          whiteSpace: "pre-line",
        }}
      >
        {helperText}
      </FormHelperText>
    </Box>
  );
}

interface InputDateProps {
  i: number;
  dataColumnName: string;
  dataColumnKey: string;
  addData: { [key: string]: string | boolean | any[] };
  setAddData: React.Dispatch<
    React.SetStateAction<{ [key: string]: string | boolean | any[] }>
  >;
  createYearList: () => string[];
  createMonthList: () => string[];
  createDateList: () => string[];
}

function InputDate(props: InputDateProps) {
  const {
    i,
    dataColumnName,
    dataColumnKey,
    addData,
    setAddData,
    createYearList,
    createMonthList,
    createDateList,
  } = props;
  return (
    <Box key={"addBox" + i}>
      <Box className="serch-label">{dataColumnName}</Box>
      <FormControl
        sx={{
          marginTop: "10px",
          marginBottom: "20px",
          marginLeft: "5px",
          width: "calc(40% - 5px)",
        }}
      >
        <Select
          disabled={
            dataColumnKey === "payment_end_date"
              ? addData["payment_end_date_post"] === true
              : false
          }
          labelId="serch-input-label"
          id="serch-input"
          value={addData[dataColumnKey + "_year"]}
          onChange={(e) => {
            setAddData((addData) => ({
              ...addData,
              [dataColumnKey + "_year"]: e.target.value,
            }));
          }}
          sx={{
            height: "30px",
            textAlign: "end",
            fontSize: "14px",
          }}
        >
          {createYearList().map((input, i) => {
            return (
              <MenuItem
                key={"input" + i}
                value={input}
                sx={{
                  fontSize: "14px",
                  height: input === "" ? "14px" : "24px",
                  minHeight: "auto",
                }}
              >
                {input}
              </MenuItem>
            );
          })}
        </Select>
      </FormControl>
      <FormControl
        sx={{
          marginTop: "10px",
          marginBottom: "20px",
          marginLeft: "5px",
          width: "calc(30% - 8px)",
        }}
      >
        <Select
          disabled={
            dataColumnKey === "payment_end_date"
              ? addData["payment_end_date_post"] === true
              : false
          }
          labelId="serch-input-label"
          id="serch-input"
          value={addData[dataColumnKey + "_month"]}
          onChange={(e) => {
            setAddData((addData) => ({
              ...addData,
              [dataColumnKey + "_month"]: e.target.value,
            }));
          }}
          sx={{
            height: "30px",
            textAlign: "end",
            fontSize: "14px",
          }}
        >
          {createMonthList().map((input, i) => {
            return (
              <MenuItem
                key={"input" + i}
                value={input}
                sx={{
                  fontSize: "14px",
                  height: input === "" ? "14px" : "24px",
                  minHeight: "auto",
                }}
              >
                {input}
              </MenuItem>
            );
          })}
        </Select>
      </FormControl>
      <FormControl
        sx={{
          marginTop: "10px",
          marginBottom: "20px",
          marginLeft: "5px",
          width: "calc(30% - 8px)",
        }}
      >
        <Select
          disabled={
            dataColumnKey === "payment_end_date"
              ? addData["payment_end_date_post"] === true
              : false
          }
          labelId="serch-input-label"
          id="serch-input"
          value={addData[dataColumnKey + "_date"]}
          onChange={(e) => {
            setAddData((addData) => ({
              ...addData,
              [dataColumnKey + "_date"]: e.target.value,
            }));
          }}
          sx={{
            height: "30px",
            textAlign: "end",
            fontSize: "14px",
          }}
        >
          {createDateList().map((input, i) => {
            return (
              <MenuItem
                key={"input" + i}
                value={input}
                sx={{
                  fontSize: "14px",
                  height: input === "" ? "14px" : "24px",
                  minHeight: "auto",
                }}
              >
                {input}
              </MenuItem>
            );
          })}
        </Select>
      </FormControl>
      {dataColumnKey === "payment_end_date" ? (
        <Box
          className="serch-label"
          sx={{ marginTop: "-20px", marginBottom: "10px" }}
        >
          <Checkbox
            checked={addData["payment_end_date_post"] === true}
            onClick={() =>
              setAddData((addData) => ({
                ...addData,
                ["payment_end_date_post"]: !addData["payment_end_date_post"],
              }))
            }
            sx={{
              "& .MuiSvgIcon-root": { fontSize: 18 },
            }}
          />
          「条件適応期間 - 終了」を登録しない
        </Box>
      ) : null}
    </Box>
  );
}

interface DataAddModalProps {
  onModal: boolean;
  swCloseModal: () => void;
  addTitle: string;
  dataColumn: DataColumn[];
  subDataColumn: SubDataColumn[];
  postAddData: () => void;
  addData: { [key: string]: string | boolean | any[] };
  setAddData: React.Dispatch<
    React.SetStateAction<{ [key: string]: string | boolean | any[] }>
  >;
  companyList: { id: number; sale_company_name: string }[];
  highRankCompanyList: { id: number; high_rank_company_name: string }[];
  staffList: { id: number; account_name: string }[];
  firstYear: number;
  thisYear: number;
  categoryList: { id: number; category_name: string }[];
  productList: { id: number; product_name: string }[];
  groupList: { id: number; group_name: string }[];
  postFiles: {
    [key: string]: File;
  };
  setPostFiles: (value: { [key: string]: File }) => void;
  sitePathList: { id: number; product_id: number; site_path: string }[];
  /** サブテーブル用の選択肢リスト（key: subDataColumn.key）。渡した場合のみ list で使用 */
  subDataColumnOptionList?: { [key: string]: { id: number; name: string }[] };
  /** サブテーブル用の依存選択肢（質問→選択肢など）。addData に応じてリストを返す。undefined の場合は subDataColumnOptionList を使用 */
  subDataColumnOptionListByKey?: (
    key: string,
    addData: { [key: string]: string | boolean | any[] },
  ) => { id: number; name: string }[] | undefined;
}

export function DataAddModal(props: DataAddModalProps) {
  const {
    onModal,
    swCloseModal,
    addTitle,
    dataColumn,
    subDataColumn,
    postAddData,
    addData,
    setAddData,
    companyList,
    highRankCompanyList,
    staffList,
    firstYear,
    thisYear,
    categoryList,
    productList,
    groupList,
    postFiles,
    setPostFiles,
    sitePathList,
    subDataColumnOptionList,
    subDataColumnOptionListByKey,
  } = props;

  const loginUser = useAtomValue(AppAtoms.loginUser);
  const { windowWidth, windowHeight } = useWindowSize();

  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: windowWidth > 868 ? "800px" : "calc(100% - 82px)",
    maxHeight: "70vh",
    bgcolor: "background.paper",
    border: "2px solid #000",
    boxShadow: 24,
    p: 4,
  };
  const createDateList = () => {
    let dateList = [];
    for (let i = 1; i <= 31; i++) {
      dateList.push(i.toString());
    }
    return dateList;
  };
  const createMonthList = () => {
    let monthList = [];
    for (let i = 1; i <= 12; i++) {
      monthList.push(i.toString());
    }
    return monthList;
  };
  const createYearList = () => {
    let yearList = [];
    for (let i = firstYear; i <= thisYear; i++) {
      yearList.push(i.toString());
    }
    return yearList;
  };

  const [onAddButton, setOnAddButton] = useState(false);
  useEffect(() => {
    let onAddButton = true;
    dataColumn.map((dataColumn, i) => {
      if (dataColumn.add) {
        if (
          dataColumn.addType === "text" ||
          dataColumn.addType === "multitext"
        ) {
          if (
            (Number(addData["sns_type"]) == 0 ||
              Number(addData["sns_type"]) == 1 ||
              (dataColumn.key !== "sns_id" &&
                dataColumn.key !== "sns_haeder" &&
                dataColumn.key !== "sns_footer")) &&
            (Number(addData["incentive_status_conf"]) === 1 ||
              dataColumn.key !== "incentive_status") &&
            (Number(addData["follow_call_entry_status_conf"]) === 1 ||
              dataColumn.key !== "follow_call_entry_status") &&
            dataColumn.key !== "payment_method" &&
            dataColumn.key !== "sns_haeder" &&
            dataColumn.key !== "sns_footer" &&
            dataColumn.key !== "service_option_name_pull_down" &&
            dataColumn.key !== "service_option_name_check_box" &&
            dataColumn.key !== "site_footer" &&
            dataColumn.key !== "service_page_url" &&
            dataColumn.key !== "outside_cancell_form_text" &&
            dataColumn.key !== "outside_cancell_form_mail_address" &&
            addData[dataColumn.key] === ""
          ) {
            onAddButton = false;
          }
        } else if (
          (dataColumn.addType === "list" &&
            (((dataColumn.key === "screen_column_auth" ||
              dataColumn.key === "login_sale_company") &&
              (loginUser?.authority === "マスターアカウント" ||
                loginUser?.authority === "スタッフアカウント")) ||
              (dataColumn.key !== "screen_column_auth" &&
                dataColumn.key !== "login_sale_company")) &&
            ((dataColumn.key === "login_collaborate_company" &&
              (loginUser?.authority === "パートナー" ||
                loginUser?.authority === "営業アカウント")) ||
              dataColumn.key !== "login_collaborate_company")) ||
          dataColumn.addType === "company" ||
          dataColumn.addType === "staff" ||
          dataColumn.addType === "high_rank_company" ||
          dataColumn.addType === "product"
        ) {
          if (
            ((dataColumn.key === "sale_company_id" &&
              (Number(addData["authority"]) === 2 ||
                Number(addData["authority"]) === 3 ||
                Number(addData["authority"]) === 4 ||
                Number(addData["authority"]) === 5)) ||
              dataColumn.key !== "sale_company_id") &&
            ((dataColumn.key === "sale_company_group_id" &&
              (Number(addData["authority"]) === 3 ||
                Number(addData["authority"]) === 4 ||
                Number(addData["authority"]) === 5)) ||
              dataColumn.key !== "sale_company_group_id") &&
            addData[dataColumn.key] === "" &&
            ((dataColumn.key === "product_contract_number" &&
              Number(addData["product_key"]) === 0) ||
              (dataColumn.key !== "product_contract_number" &&
                addData[dataColumn.key] === "")) &&
            ((dataColumn.key === "entry_sale_company_group" &&
              Number(addData["entry_sale_company_id"]) !== 0) ||
              (dataColumn.key !== "entry_sale_company_group" &&
                addData[dataColumn.key] === "")) &&
            ((dataColumn.key === "login_sale_company" &&
              Number(addData["screen_column_auth"]) === 0) ||
              (dataColumn.key !== "login_sale_company" &&
                addData[dataColumn.key] === "")) &&
            // addData["service_type"] はリスト選択時に id.toString() (e.g. "2","3") で格納されるため Number() 変換が正常に機能する
            !(
              dataColumn.key === "sns_send_flg" &&
              Number(addData["service_type"]) !== 2 &&
              Number(addData["service_type"]) !== 3
            )
          ) {
            onAddButton = false;
          }
        } else if (dataColumn.addType === "product_option") {
          const optionArray = addData["product_option"] as any[];
          optionArray.map((option, option_i) => {
            if (option["option_name"] === "") {
              onAddButton = false;
            }
          });
        } else if (
          dataColumn.addType === "outside_site_logo" ||
          dataColumn.addType === "outside_site_favicon"
        ) {
          if (!postFiles[dataColumn.key]) {
            onAddButton = false;
          }
        }
      }
    });
    subDataColumn.map((dataColumn, i) => {
      if (dataColumn.add) {
        if (
          dataColumn.addType === "text" ||
          dataColumn.addType === "multitext"
        ) {
          if (
            (Number(addData["trading_type"]) === 1 || Number(addData["trading_type"]) === 3 ||
              dataColumn.key !== "unique_payment_name") &&
            (Number(addData["outside_sms_type"]) === 1 ||
              dataColumn.key !== "outside_sms_title") &&
            (Number(addData["cancell_sms_type"]) === 1 ||
              dataColumn.key !== "cancell_sms_title") &&
            (Number(addData["sns_type"]) !== 2 ||
              dataColumn.key !== "sns_id") &&
            (Number(addData["cancell_sns_type"]) !== 2 ||
              dataColumn.key !== "cancell_sns_id") &&
            dataColumn.key !== "customer_list_id" &&
            dataColumn.key !== "sns_haeder" &&
            dataColumn.key !== "sns_footer" &&
            dataColumn.key !== "cancell_sns_haeder" &&
            dataColumn.key !== "cancell_sns_footer" &&
            addData[dataColumn.key] === ""
          ) {
            onAddButton = false;
          }
        } else if (
          dataColumn.addType === "list" ||
          dataColumn.addType === "company"
        ) {
          if (
            (Number(addData["sns_type"]) !== 2 ||
              dataColumn.key !== "sns_toss_up_account_info") &&
            (Number(addData["trading_type"]) === 1 || Number(addData["trading_type"]) === 3 ||
              dataColumn.key !== "service_toss_up_company_id") &&
            (Number(addData["trading_type"]) === 2 || Number(addData["trading_type"]) === 3 ||
              dataColumn.key !== "back_payment_time") &&
            addData[dataColumn.key] === ""
          ) {
            onAddButton = false;
          }
        } else if (dataColumn.addType === "site_pdf_path") {
          if (!postFiles[dataColumn.key]) {
            onAddButton = false;
          }
        }
      }
    });
    setOnAddButton(onAddButton);
  }, [addData, postFiles]);

  return (
    <Modal
      open={onModal}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      data-testid="data-add-modal"
    >
      <Box sx={style}>
        <Box
          style={{
            fontSize: "18px",
            color: "rgb(50 50 50)",
          }}
          key="serchTitleBox"
          className="shippori-antique-regular"
        >
          {addTitle}
        </Box>
        <Typography
          id="modal-modal-description"
          sx={{
            mt: 2,
            mb: 5,
            maxHeight: windowWidth > 385 ? undefined : "calc(70vh - 30px)",
            overflowY: windowWidth > 385 ? undefined : "auto",
          }}
        >
          <Paper elevation={0}>
            <Box
              sx={{
                maxHeight: windowWidth > 385 ? "calc(70vh - 80px)" : undefined,
                overflowY: windowWidth > 385 ? "auto" : undefined,
              }}
            >
              {dataColumn.map((dataColumn, i) => {
                if (dataColumn.add) {
                  if (
                    dataColumn.addType === "text" ||
                    dataColumn.addType === "multitext"
                  ) {
                    return (
                      <SerchTextField
                        disable={false}
                        width="calc(100% - 10px)"
                        key={"serchColumnBubun" + i}
                        data-testid={`add-modal-field-${dataColumn.key}`}
                        label={dataColumn.name}
                        helperText={
                          dataColumn.key === "document_title"
                            ? "例：" + loginUser?.title
                            : dataColumn.addMessage
                        }
                        value={addData[dataColumn.key] as string}
                        setValue={(value) => {
                          setAddData((addData) => ({
                            ...addData,
                            [dataColumn.key]: value,
                          }));
                        }}
                        dataKey={dataColumn.key}
                        addData={addData}
                        multiline={
                          dataColumn.addType === "multitext" ? true : false
                        }
                      />
                    );
                  } else if (dataColumn.addType === "list") {
                    if (
                      dataColumn.key === "authority" &&
                      (loginUser?.authority === "マスターアカウント" ||
                        loginUser?.authority === "スタッフアカウント")
                    ) {
                      return (
                        <Box key={"addBox" + i} data-testid={`add-modal-field-${dataColumn.key}`}>
                          <Box className="serch-label">{dataColumn.name}</Box>
                          <SerchInputField
                            disabled={false}
                            key={"serchColumnList" + i}
                            inputList={LIST_POST["authority"]}
                            inputListKey={"value"}
                            helperText={dataColumn.addMessage}
                            label=""
                            marginLeft="5px"
                            width="calc(100% - 10px)"
                            value={addData["authority_name"] as string}
                            setAddData={setAddData}
                            dataKey={"authority"}
                            addData={addData}
                          />
                        </Box>
                      );
                    } else if (
                      dataColumn.key === "authority" &&
                      loginUser?.authority === "パートナー"
                    ) {
                      return (
                        <Box key={"addBox" + i} data-testid={`add-modal-field-${dataColumn.key}`}>
                          <Box className="serch-label">{dataColumn.name}</Box>
                          <SerchInputField
                            disabled={false}
                            key={"serchColumnList" + i}
                            inputList={LIST_POST["partner_authority"]}
                            inputListKey={"value"}
                            helperText={dataColumn.addMessage}
                            label=""
                            marginLeft="5px"
                            width="calc(100% - 10px)"
                            value={addData["authority_name"] as string}
                            setAddData={setAddData}
                            dataKey={"authority"}
                            addData={addData}
                          />
                        </Box>
                      );
                    } else if (
                      dataColumn.key === "follow_call_day_offset" &&
                      addData.follow_call_base_day_conf === "2"
                    ) {
                      return (
                        <Box key={"addBox" + i} data-testid={`add-modal-field-${dataColumn.key}`}>
                          <Box className="serch-label">{dataColumn.name}</Box>
                          <SerchInputField
                            disabled={false}
                            key={"serchColumnList" + i}
                            inputList={LIST_POST["follow_call_day_offset_open"]}
                            inputListKey={"value"}
                            helperText={dataColumn.addMessage}
                            label=""
                            marginLeft="5px"
                            width="calc(100% - 10px)"
                            value={addData[dataColumn.key + "_name"] as string}
                            setAddData={setAddData}
                            dataKey={dataColumn.key}
                            addData={addData}
                          />
                        </Box>
                      );
                    } else if (
                      (((dataColumn.key === "screen_column_auth" ||
                        dataColumn.key === "login_sale_company") &&
                        (loginUser?.authority === "マスターアカウント" ||
                          loginUser?.authority === "スタッフアカウント")) ||
                        (dataColumn.key !== "screen_column_auth" &&
                          dataColumn.key !== "login_sale_company")) &&
                      ((dataColumn.key === "login_collaborate_company" &&
                        (loginUser?.authority === "パートナー" ||
                          loginUser?.authority === "営業アカウント")) ||
                        dataColumn.key !== "login_collaborate_company") &&
                      // addData["service_type"] はリスト選択時に id.toString() (e.g. "2","3") で格納されるため Number() 変換が正常に機能する
                      ((dataColumn.key === "sns_send_flg" &&
                        (Number(addData["service_type"]) === 2 ||
                          Number(addData["service_type"]) === 3)) ||
                        dataColumn.key !== "sns_send_flg")
                    ) {
                      return (
                        <Box key={"addBox" + i} data-testid={`add-modal-field-${dataColumn.key}`}>
                          <Box className="serch-label">{dataColumn.name}</Box>
                          <SerchInputField
                            disabled={
                              dataColumn.key === "product_contract_number"
                                ? Number(addData.product_key) === 1
                                  ? true
                                  : false
                                : false
                            }
                            key={"serchColumnList" + i}
                            inputList={LIST_POST[dataColumn.key]}
                            inputListKey={"value"}
                            helperText={dataColumn.addMessage}
                            label=""
                            marginLeft="5px"
                            width="calc(100% - 10px)"
                            value={addData[dataColumn.key + "_name"] as string}
                            setAddData={setAddData}
                            dataKey={dataColumn.key}
                            addData={addData}
                          />
                        </Box>
                      );
                    }
                  } else if (dataColumn.addType === "company") {
                    if (
                      loginUser?.authority === "マスターアカウント" ||
                      loginUser?.authority === "スタッフアカウント"
                    ) {
                      return (
                        <Box key={"addBox" + i} data-testid={`add-modal-field-${dataColumn.key}`}>
                          <Box className="serch-label">{dataColumn.name}</Box>
                          <SerchInputField
                            disabled={
                              addData.authority === undefined
                                ? false
                                : Number(addData.authority) === 0 ||
                                    Number(addData.authority) === 1
                                  ? true
                                  : false
                            }
                            key={"serchColumnList" + i}
                            inputList={companyList}
                            inputListKey={"sale_company_name"}
                            helperText={dataColumn.addMessage}
                            label=""
                            marginLeft="5px"
                            width="calc(100% - 10px)"
                            value={addData[dataColumn.key + "_name"] as string}
                            setAddData={setAddData}
                            dataKey={dataColumn.key}
                            addData={addData}
                          />
                        </Box>
                      );
                    }
                  } else if (dataColumn.addType === "high_rank_company") {
                    return (
                      <Box key={"addBox" + i} data-testid={`add-modal-field-${dataColumn.key}`}>
                        <Box className="serch-label">{dataColumn.name}</Box>
                        <SerchInputField
                          disabled={false}
                          key={"serchColumnList" + i}
                          inputList={highRankCompanyList}
                          inputListKey={"high_rank_company_name"}
                          helperText={dataColumn.addMessage}
                          label=""
                          marginLeft="5px"
                          width="calc(100% - 10px)"
                          value={addData[dataColumn.key + "_name"] as string}
                          setAddData={setAddData}
                          dataKey={dataColumn.key}
                          addData={addData}
                        />
                      </Box>
                    );
                  } else if (dataColumn.addType === "category") {
                    return (
                      <Box key={"addBox" + i} data-testid={`add-modal-field-${dataColumn.key}`}>
                        <Box className="serch-label">{dataColumn.name}</Box>
                        <SerchInputField
                          disabled={false}
                          key={"serchColumnList" + i}
                          inputList={categoryList}
                          inputListKey={"category_name"}
                          helperText={dataColumn.addMessage}
                          label=""
                          marginLeft="5px"
                          width="calc(100% - 10px)"
                          value={addData[dataColumn.key + "_name"] as string}
                          setAddData={setAddData}
                          dataKey={dataColumn.key}
                          addData={addData}
                        />
                      </Box>
                    );
                  } else if (dataColumn.addType === "product") {
                    return (
                      <Box key={"addBox" + i} data-testid={`add-modal-field-${dataColumn.key}`}>
                        <Box className="serch-label">{dataColumn.name}</Box>
                        <SerchInputField
                          disabled={false}
                          key={"serchColumnList" + i}
                          inputList={productList}
                          inputListKey={"product_name"}
                          helperText={dataColumn.addMessage}
                          label=""
                          marginLeft="5px"
                          width="calc(100% - 10px)"
                          value={addData[dataColumn.key + "_name"] as string}
                          setAddData={setAddData}
                          dataKey={dataColumn.key}
                          addData={addData}
                        />
                      </Box>
                    );
                  } else if (dataColumn.addType === "outside_site_path") {
                    return (
                      <Box key={"addBox" + i} data-testid={`add-modal-field-${dataColumn.key}`}>
                        <Box className="serch-label">{dataColumn.name}</Box>
                        <SerchInputField
                          disabled={false}
                          key={"serchColumnList" + i}
                          inputList={sitePathList}
                          inputListKey={"site_path"}
                          helperText={dataColumn.addMessage}
                          label=""
                          marginLeft="5px"
                          width="calc(100% - 10px)"
                          value={addData[dataColumn.key + "_name"] as string}
                          setAddData={setAddData}
                          dataKey={dataColumn.key}
                          addData={addData}
                        />
                      </Box>
                    );
                  } else if (dataColumn.addType === "staff") {
                    return (
                      <Box key={"addBox" + i} data-testid={`add-modal-field-${dataColumn.key}`}>
                        <Box className="serch-label">{dataColumn.name}</Box>
                        <SerchInputField
                          disabled={false}
                          key={"serchColumnList" + i}
                          inputList={staffList}
                          inputListKey={"account_name"}
                          helperText={dataColumn.addMessage}
                          label=""
                          marginLeft="5px"
                          width="calc(100% - 10px)"
                          value={addData[dataColumn.key + "_name"] as string}
                          setAddData={setAddData}
                          dataKey={dataColumn.key}
                          addData={addData}
                        />
                      </Box>
                    );
                  } else if (dataColumn.addType === "group") {
                    return (
                      <Box key={"addBox" + i} data-testid={`add-modal-field-${dataColumn.key}`}>
                        <Box className="serch-label">{dataColumn.name}</Box>
                        <SerchInputField
                          disabled={
                            addData.authority === undefined
                              ? false
                              : Number(addData.authority) === 0 ||
                                  Number(addData.authority) === 1 ||
                                  Number(addData.authority) === 2
                                ? true
                                : false
                          }
                          key={"serchColumnList" + i}
                          inputList={groupList}
                          inputListKey={"group_name"}
                          helperText={dataColumn.addMessage}
                          label=""
                          marginLeft="5px"
                          width="calc(100% - 10px)"
                          value={addData[dataColumn.key + "_name"] as string}
                          setAddData={setAddData}
                          dataKey={dataColumn.key}
                          addData={addData}
                        />
                      </Box>
                    );
                  } else if (dataColumn.addType === "date") {
                    return (
                      <InputDate
                        i={i}
                        dataColumnName={dataColumn.name}
                        dataColumnKey={dataColumn.key}
                        addData={addData}
                        setAddData={setAddData}
                        createYearList={createYearList}
                        createMonthList={createMonthList}
                        createDateList={createDateList}
                      />
                    );
                  } else if (dataColumn.addType === "payment_method") {
                    const paymentMethodArray = addData[
                      "payment_method"
                    ] as string[];
                    return (
                      <>
                        {paymentMethodArray.map((paymentMethod, payment_i) => {
                          return (
                            <Box
                              key={"addBoxPaymentMethod_" + i + "_" + payment_i}
                            >
                              <SerchTextField
                                disable={false}
                                width="calc(100% - 80px)"
                                key={"addBoxPaymentMetho" + i}
                                label={"支払方法 - " + (payment_i + 1)}
                                helperText={
                                  payment_i + 1 === paymentMethodArray.length
                                    ? dataColumn.addMessage
                                    : ""
                                }
                                value={paymentMethod as string}
                                setValue={(value) => {
                                  let _paymentMethodArray =
                                    paymentMethodArray.concat();
                                  _paymentMethodArray[payment_i] = value;
                                  setAddData((addData) => ({
                                    ...addData,
                                    payment_method: _paymentMethodArray,
                                  }));
                                }}
                                dataKey={"payment_method"}
                                addData={addData}
                                multiline={false}
                              />
                              {paymentMethodArray.length > 1 ? (
                                <Button
                                  style={{
                                    height: "32px",
                                    width: "32px",
                                    marginLeft: "calc(100% - 75px)",
                                    marginTop: "-110px",
                                  }}
                                  onClick={(e) => {
                                    let _paymentMethodArray =
                                      paymentMethodArray.concat();
                                    _paymentMethodArray =
                                      _paymentMethodArray.filter(
                                        (_paymentMethod, _payment_i) =>
                                          payment_i !== _payment_i,
                                      );
                                    setAddData((addData) => ({
                                      ...addData,
                                      payment_method: _paymentMethodArray,
                                    }));
                                  }}
                                >
                                  <RemoveCircleOutlineIcon fontSize="medium" />
                                </Button>
                              ) : null}
                            </Box>
                          );
                        })}
                        <Box
                          key={"addBoxPriceDataDelete"}
                          sx={{ height: "20px" }}
                        >
                          <Button
                            style={{
                              fontSize: "20px",
                              marginTop: "-10px",
                              marginLeft: "calc(100% - 140px)",
                            }}
                            onClick={() => {
                              let _paymentMethodArray =
                                paymentMethodArray.concat();
                              _paymentMethodArray.push("");
                              setAddData((addData) => ({
                                ...addData,
                                payment_method: _paymentMethodArray,
                              }));
                            }}
                          >
                            <AddCircleOutlineIcon fontSize="medium" />
                          </Button>
                        </Box>
                      </>
                    );
                  } else if (
                    dataColumn.addType === "screen_column_selects" &&
                    (String(addData["screen_column_type"]) === "1" ||
                      String(addData["screen_column_type"]) === "2")
                  ) {
                    const screenColumnSelectArray = addData[
                      "screen_column_selects"
                    ] as string[];
                    return (
                      <>
                        {screenColumnSelectArray.map(
                          (paymentMethod, select_i) => {
                            return (
                              <Box
                                key={
                                  "addBoxPaymentMethod_" + i + "_" + select_i
                                }
                              >
                                <SerchTextField
                                  disable={false}
                                  width="calc(100% - 80px)"
                                  key={"addBoxPaymentMetho" + i}
                                  label={"選択肢 - " + (select_i + 1)}
                                  helperText={
                                    select_i + 1 ===
                                    screenColumnSelectArray.length
                                      ? dataColumn.addMessage
                                      : ""
                                  }
                                  value={paymentMethod as string}
                                  setValue={(value) => {
                                    let _screenColumnSelectArray =
                                      screenColumnSelectArray.concat();
                                    _screenColumnSelectArray[select_i] = value;
                                    setAddData((addData) => ({
                                      ...addData,
                                      screen_column_selects:
                                        _screenColumnSelectArray,
                                    }));
                                  }}
                                  dataKey={"screen_column_selects"}
                                  addData={addData}
                                  multiline={false}
                                />
                                {screenColumnSelectArray.length > 1 ? (
                                  <Button
                                    style={{
                                      height: "32px",
                                      width: "32px",
                                      marginLeft: "calc(100% - 75px)",
                                      marginTop: "-110px",
                                    }}
                                    onClick={(e) => {
                                      let _screenColumnSelectArray =
                                        screenColumnSelectArray.concat();
                                      _screenColumnSelectArray =
                                        _screenColumnSelectArray.filter(
                                          (_paymentMethod, _select_i) =>
                                            select_i !== _select_i,
                                        );
                                      setAddData((addData) => ({
                                        ...addData,
                                        screen_column_selects:
                                          _screenColumnSelectArray,
                                      }));
                                    }}
                                  >
                                    <RemoveCircleOutlineIcon fontSize="medium" />
                                  </Button>
                                ) : null}
                              </Box>
                            );
                          },
                        )}
                        <Box
                          key={"addBoxPriceDataDelete"}
                          sx={{ height: "20px" }}
                        >
                          <Button
                            style={{
                              fontSize: "20px",
                              marginTop: "-10px",
                              marginLeft: "calc(100% - 140px)",
                            }}
                            onClick={() => {
                              let _screenColumnSelectArray =
                                screenColumnSelectArray.concat();
                              _screenColumnSelectArray.push("");
                              setAddData((addData) => ({
                                ...addData,
                                screen_column_selects: _screenColumnSelectArray,
                              }));
                            }}
                          >
                            <AddCircleOutlineIcon fontSize="medium" />
                          </Button>
                        </Box>
                      </>
                    );
                  } else if (
                    dataColumn.addType === "outside_site_logo" ||
                    dataColumn.addType === "outside_site_favicon"
                  ) {
                    return (
                      <Box key={"addBox" + i} data-testid={`add-modal-field-${dataColumn.key}`}>
                        <Box className="serch-label">{dataColumn.name}</Box>
                        <input
                          id="textFieldFiles"
                          type="file"
                          onChange={(
                            event_file: React.ChangeEvent<HTMLInputElement>,
                          ) => {
                            if (
                              event_file.target.files &&
                              event_file.target.files.length > 0
                            ) {
                              const file = event_file.target.files[0];
                              const updatedPostPictures = {
                                ...postFiles,
                                [dataColumn.key]: file,
                              };
                              setPostFiles(updatedPostPictures);
                            }
                          }}
                        />
                        <FormHelperText
                          id="serch-name"
                          sx={{
                            width: "calc(100% - 10px)",
                            textAlign: "right",
                            marginTop: "-8px",
                            height: "25px",
                            whiteSpace: "pre-line",
                          }}
                        >
                          {dataColumn.addMessage}
                        </FormHelperText>
                      </Box>
                    );
                  }
                }
              })}
              {subDataColumn.map((dataColumn, i) => {
                if (dataColumn.add) {
                  if (
                    dataColumn.addType === "text" ||
                    dataColumn.addType === "multitext"
                  ) {
                    return (
                      <SerchTextField
                        disable={false}
                        width="calc(100% - 10px)"
                        key={"serchColumnBubun" + i}
                        data-testid={`add-modal-field-${dataColumn.key}`}
                        label={dataColumn.name}
                        helperText={dataColumn.addMessage}
                        value={addData[dataColumn.key] as string}
                        setValue={(value) => {
                          setAddData((addData) => ({
                            ...addData,
                            [dataColumn.key]: value,
                          }));
                        }}
                        dataKey={dataColumn.key}
                        addData={addData}
                        multiline={
                          dataColumn.addType === "multitext" ? true : false
                        }
                      />
                    );
                  } else if (dataColumn.addType === "tableData") {
                    return (
                      <SerchTextField
                        disable={true}
                        width="calc(100% - 10px)"
                        key={"serchColumnBubun" + i}
                        label={dataColumn.name}
                        helperText={dataColumn.addMessage}
                        value={addData[dataColumn.key] as string}
                        setValue={(value) => {}}
                        dataKey={dataColumn.key}
                        addData={addData}
                        multiline={false}
                      />
                    );
                  } else if (dataColumn.addType === "list") {
                    const dependList = subDataColumnOptionListByKey?.(
                      dataColumn.key,
                      addData,
                    );
                    if (dependList !== undefined) {
                      const selectedName =
                        dependList.find(
                          (o) =>
                            String(o.id) === String(addData[dataColumn.key]),
                        )?.name ?? "";
                      return (
                        <Box key={"addBox" + i} data-testid={`add-modal-field-${dataColumn.key}`}>
                          <Box className="serch-label">{dataColumn.name}</Box>
                          <SerchInputField
                            disabled={dependList.length === 0}
                            key={"serchColumnList" + i}
                            inputList={dependList}
                            inputListKey="name"
                            helperText={dataColumn.addMessage}
                            label=""
                            marginLeft="5px"
                            width="calc(100% - 10px)"
                            value={selectedName}
                            setAddData={setAddData}
                            dataKey={dataColumn.key}
                            addData={addData}
                          />
                        </Box>
                      );
                    }
                    if (
                      subDataColumnOptionList &&
                      subDataColumnOptionList[dataColumn.key]
                    ) {
                      const optList = subDataColumnOptionList[dataColumn.key];
                      const selectedName =
                        optList.find(
                          (o) =>
                            String(o.id) === String(addData[dataColumn.key]),
                        )?.name ?? "";
                      return (
                        <Box key={"addBox" + i} data-testid={`add-modal-field-${dataColumn.key}`}>
                          <Box className="serch-label">{dataColumn.name}</Box>
                          <SerchInputField
                            disabled={false}
                            key={"serchColumnList" + i}
                            inputList={optList}
                            inputListKey="name"
                            helperText={dataColumn.addMessage}
                            label=""
                            marginLeft="5px"
                            width="calc(100% - 10px)"
                            value={selectedName}
                            setAddData={setAddData}
                            dataKey={dataColumn.key}
                            addData={addData}
                          />
                        </Box>
                      );
                    } else if (
                      dataColumn.key === "trading_type" &&
                      addTitle === "入金単価追加"
                    ) {
                      return (
                        <Box key={"addBox" + i} data-testid={`add-modal-field-${dataColumn.key}`}>
                          <Box className="serch-label">{dataColumn.name}</Box>
                          <SerchInputField
                            disabled={false}
                            key={"serchColumnList" + i}
                            inputList={LIST_POST["trading_type_high_rank"]}
                            inputListKey={"value"}
                            helperText={dataColumn.addMessage}
                            label=""
                            marginLeft="5px"
                            width="calc(100% - 10px)"
                            value={addData[dataColumn.key + "_name"] as string}
                            setAddData={setAddData}
                            dataKey={dataColumn.key}
                            addData={addData}
                          />
                        </Box>
                      );
                    } else {
                      return (
                        <Box key={"addBox" + i} data-testid={`add-modal-field-${dataColumn.key}`}>
                          <Box className="serch-label">{dataColumn.name}</Box>
                          <SerchInputField
                            disabled={
                              dataColumn.key == "back_payment_time" &&
                              Number(addData.trading_type) !== 2 &&
                              Number(addData.trading_type) !== 3
                                ? true
                                : dataColumn.key ==
                                      "sns_toss_up_account_info" &&
                                    Number(addData.sns_type) === 2
                                  ? true
                                  : false
                            }
                            key={"serchColumnList" + i}
                            inputList={LIST_POST[dataColumn.key]}
                            inputListKey={"value"}
                            helperText={dataColumn.addMessage}
                            label=""
                            marginLeft="5px"
                            width="calc(100% - 10px)"
                            value={addData[dataColumn.key + "_name"] as string}
                            setAddData={setAddData}
                            dataKey={dataColumn.key}
                            addData={addData}
                          />
                        </Box>
                      );
                    }
                  } else if (dataColumn.addType === "date") {
                    return (
                      <InputDate
                        i={i}
                        dataColumnName={dataColumn.name}
                        dataColumnKey={dataColumn.key}
                        addData={addData}
                        setAddData={setAddData}
                        createYearList={createYearList}
                        createMonthList={createMonthList}
                        createDateList={createDateList}
                      />
                    );
                  } else if (dataColumn.addType === "company") {
                    if (
                      loginUser?.authority === "マスターアカウント" ||
                      loginUser?.authority === "スタッフアカウント"
                    ) {
                      const tossUpCompanyList = [
                        {
                          id: 0,
                          sale_company_name: "トスアップパートナーを設定しない",
                        },
                        ...companyList,
                      ];
                      return (
                        <Box key={"addBox" + i} data-testid={`add-modal-field-${dataColumn.key}`}>
                          <Box className="serch-label">{dataColumn.name}</Box>
                          <SerchInputField
                            disabled={false}
                            key={"serchColumnList" + i}
                            inputList={
                              dataColumn.key === "service_toss_up_company_id"
                                ? tossUpCompanyList
                                : companyList
                            }
                            inputListKey={"sale_company_name"}
                            helperText={dataColumn.addMessage}
                            label=""
                            marginLeft="5px"
                            width="calc(100% - 10px)"
                            value={addData[dataColumn.key + "_name"] as string}
                            setAddData={setAddData}
                            dataKey={dataColumn.key}
                            addData={addData}
                          />
                        </Box>
                      );
                    }
                  } else if (
                    dataColumn.addType === "mgr_product" &&
                    addData.all_product
                  ) {
                    return (
                      <Box key={"addBox" + i} data-testid={`add-modal-field-${dataColumn.key}`}>
                        <Box className="serch-label">{dataColumn.name}</Box>
                        {(addData.all_product as any[]).map(
                          (product: {
                            product_id: string;
                            product_name: string;
                          }) => {
                            return (
                              <Box
                                className="serch-label"
                                sx={{ marginRight: "25px" }}
                              >
                                <Checkbox
                                  checked={
                                    (addData.select_product as any[]).findIndex(
                                      (_product) =>
                                        product.product_id ===
                                        _product.product_id,
                                    ) > -1
                                  }
                                  onClick={() => {
                                    let _select_product = (
                                      addData.select_product as any[]
                                    ).concat();
                                    if (
                                      (
                                        addData.select_product as any[]
                                      ).findIndex(
                                        (_product) =>
                                          product.product_id ===
                                          _product.product_id,
                                      ) > -1
                                    ) {
                                      _select_product = _select_product.filter(
                                        (_product) =>
                                          product.product_id !==
                                          _product.product_id,
                                      );
                                    } else {
                                      _select_product.push(product);
                                    }
                                    setAddData((addData) => ({
                                      ...addData,
                                      select_product: _select_product,
                                    }));
                                  }}
                                />
                                {product.product_name}
                              </Box>
                            );
                          },
                        )}
                      </Box>
                    );
                  } else if (
                    dataColumn.addType === "mgr_group" &&
                    addData.all_group
                  ) {
                    return (
                      <Box key={"addBox" + i} data-testid={`add-modal-field-${dataColumn.key}`}>
                        <Box className="serch-label">{dataColumn.name}</Box>
                        {(addData.all_group as any[]).map(
                          (group: {
                            group_id: string;
                            group_name: string;
                            sale_company_name?: string;
                          }) => {
                            const displayName =
                              group.sale_company_name != null &&
                              group.sale_company_name !== ""
                                ? `${group.sale_company_name} / ${group.group_name}`
                                : group.group_name;
                            // パートナー時：協業パートナーのグループは選択・解除不可
                            const isPartnerCollaborateGroup =
                              loginUser?.authority === "パートナー" &&
                              group.sale_company_name != null &&
                              group.sale_company_name !== "" &&
                              group.sale_company_name !== loginUser?.company;
                            return (
                              <Box
                                className="serch-label"
                                sx={{ marginRight: "25px" }}
                              >
                                <Checkbox
                                  disabled={isPartnerCollaborateGroup}
                                  checked={
                                    (addData.select_group as any[]).findIndex(
                                      (_group) =>
                                        group.group_id === _group.group_id,
                                    ) > -1
                                  }
                                  onClick={() => {
                                    let _select_group = (
                                      addData.select_group as any[]
                                    ).concat();
                                    if (
                                      (addData.select_group as any[]).findIndex(
                                        (_group) =>
                                          group.group_id === _group.group_id,
                                      ) > -1
                                    ) {
                                      _select_group = _select_group.filter(
                                        (_group) =>
                                          group.group_id !== _group.group_id,
                                      );
                                    } else {
                                      _select_group.push(group);
                                    }
                                    setAddData((addData) => ({
                                      ...addData,
                                      select_group: _select_group,
                                    }));
                                  }}
                                />
                                {displayName}
                              </Box>
                            );
                          },
                        )}
                      </Box>
                    );
                  } else if (
                    dataColumn.addType === "toss_up_product" &&
                    addData.all_product
                  ) {
                    return (
                      <Box key={"addBox" + i} data-testid={`add-modal-field-${dataColumn.key}`}>
                        <Box className="serch-label">{dataColumn.name}</Box>
                        {(addData.all_product as any[]).map(
                          (product: {
                            high_rank_company_name: string;
                            product_id: string;
                            product_name: string;
                          }) => {
                            return (
                              <Box
                                className="serch-label"
                                sx={{ marginRight: "25px" }}
                              >
                                <Checkbox
                                  checked={
                                    (addData.select_product as any[]).findIndex(
                                      (_product) =>
                                        product.product_id ===
                                        _product.product_id,
                                    ) > -1
                                  }
                                  onClick={() => {
                                    let _select_product = (
                                      addData.select_product as any[]
                                    ).concat();
                                    if (
                                      (
                                        addData.select_product as any[]
                                      ).findIndex(
                                        (_product) =>
                                          product.product_id ===
                                          _product.product_id,
                                      ) > -1
                                    ) {
                                      _select_product = _select_product.filter(
                                        (_product) =>
                                          product.product_id !==
                                          _product.product_id,
                                      );
                                    } else {
                                      _select_product.push(product);
                                    }
                                    setAddData((addData) => ({
                                      ...addData,
                                      select_product: _select_product,
                                    }));
                                  }}
                                />
                                {`${product.high_rank_company_name} / ${product.product_name}`}
                              </Box>
                            );
                          },
                        )}
                        <FormHelperText
                          id="serch-name"
                          sx={{
                            textAlign: "right",
                            minHeight: "25px",
                            whiteSpace: "pre-line",
                          }}
                        >
                          {dataColumn.addMessage}
                        </FormHelperText>
                      </Box>
                    );
                  } else if (
                    dataColumn.addType === "entry_product" &&
                    addData.all_product
                  ) {
                    return (
                      <Box key={"addBox" + i} data-testid={`add-modal-field-${dataColumn.key}`}>
                        <Box className="serch-label">{dataColumn.name}</Box>
                        {(addData.all_product as any[]).map(
                          (product: {
                            high_rank_company_name: string;
                            product_id: string;
                            product_name: string;
                          }) => {
                            const disabled =
                              (addData.select_product as any[]).findIndex(
                                (_product) =>
                                  product.product_name ===
                                  _product.product_name,
                              ) >
                                -1 !==
                              (addData.select_product as any[]).findIndex(
                                (_product) =>
                                  product.product_id === _product.product_id,
                              ) >
                                -1;
                            return (
                              <Box
                                className="serch-label"
                                sx={{ marginRight: "25px" }}
                              >
                                <Checkbox
                                  disabled={disabled}
                                  checked={
                                    (addData.select_product as any[]).findIndex(
                                      (_product) =>
                                        product.product_id ===
                                        _product.product_id,
                                    ) > -1
                                  }
                                  onClick={() => {
                                    let _select_product = (
                                      addData.select_product as any[]
                                    ).concat();
                                    if (
                                      (
                                        addData.select_product as any[]
                                      ).findIndex(
                                        (_product) =>
                                          product.product_id ===
                                          _product.product_id,
                                      ) > -1
                                    ) {
                                      _select_product = _select_product.filter(
                                        (_product) =>
                                          product.product_id !==
                                          _product.product_id,
                                      );
                                    } else {
                                      _select_product.push(product);
                                    }
                                    setAddData((addData) => ({
                                      ...addData,
                                      select_product: _select_product,
                                    }));
                                  }}
                                />
                                {`${product.high_rank_company_name} / ${product.product_name}`}
                              </Box>
                            );
                          },
                        )}
                        <FormHelperText
                          id="serch-name"
                          sx={{
                            textAlign: "right",
                            minHeight: "25px",
                            whiteSpace: "pre-line",
                          }}
                        >
                          {dataColumn.addMessage}
                        </FormHelperText>
                      </Box>
                    );
                  } else if (
                    dataColumn.addType === "toss_up_sale_company" &&
                    addData.all_sale_company
                  ) {
                    return (
                      <Box key={"addBox" + i} data-testid={`add-modal-field-${dataColumn.key}`}>
                        <Box className="serch-label">{dataColumn.name}</Box>
                        {(addData.all_sale_company as any[]).map(
                          (sale_company: {
                            sale_company_id: string;
                            sale_company_name: string;
                          }) => {
                            return (
                              <Box
                                className="serch-label"
                                sx={{ marginRight: "25px" }}
                              >
                                <Checkbox
                                  checked={
                                    (
                                      addData.select_sale_company as any[]
                                    ).findIndex(
                                      (_sale_company) =>
                                        sale_company.sale_company_id ===
                                        _sale_company.sale_company_id,
                                    ) > -1
                                  }
                                  onClick={() => {
                                    let _select_sale_company = (
                                      addData.select_sale_company as any[]
                                    ).concat();
                                    if (
                                      (
                                        addData.select_sale_company as any[]
                                      ).findIndex(
                                        (_sale_company) =>
                                          sale_company.sale_company_id ===
                                          _sale_company.sale_company_id,
                                      ) > -1
                                    ) {
                                      _select_sale_company =
                                        _select_sale_company.filter(
                                          (_sale_company) =>
                                            sale_company.sale_company_id !==
                                            _sale_company.sale_company_id,
                                        );
                                    } else {
                                      _select_sale_company.push(sale_company);
                                    }
                                    setAddData((addData) => ({
                                      ...addData,
                                      select_sale_company: _select_sale_company,
                                    }));
                                  }}
                                />
                                {sale_company.sale_company_name}
                              </Box>
                            );
                          },
                        )}
                        <FormHelperText
                          id="serch-name"
                          sx={{
                            textAlign: "right",
                            minHeight: "25px",
                            whiteSpace: "pre-line",
                          }}
                        >
                          {dataColumn.addMessage}
                        </FormHelperText>
                      </Box>
                    );
                  } else if (
                    dataColumn.addType === "entry_sale_company" &&
                    addData.all_sale_company
                  ) {
                    return (
                      <Box key={"addBox" + i} data-testid={`add-modal-field-${dataColumn.key}`}>
                        <Box className="serch-label">{dataColumn.name}</Box>
                        {(addData.all_sale_company as any[]).map(
                          (sale_company: {
                            sale_company_id: string;
                            sale_company_name: string;
                          }) => {
                            return (
                              <Box
                                className="serch-label"
                                sx={{ marginRight: "25px" }}
                              >
                                <Checkbox
                                  checked={
                                    (
                                      addData.select_sale_company as any[]
                                    ).findIndex(
                                      (_sale_company) =>
                                        sale_company.sale_company_id ===
                                        _sale_company.sale_company_id,
                                    ) > -1
                                  }
                                  onClick={() => {
                                    let _select_sale_company = (
                                      addData.select_sale_company as any[]
                                    ).concat();
                                    if (
                                      (
                                        addData.select_sale_company as any[]
                                      ).findIndex(
                                        (_sale_company) =>
                                          sale_company.sale_company_id ===
                                          _sale_company.sale_company_id,
                                      ) > -1
                                    ) {
                                      _select_sale_company =
                                        _select_sale_company.filter(
                                          (_sale_company) =>
                                            sale_company.sale_company_id !==
                                            _sale_company.sale_company_id,
                                        );
                                    } else {
                                      _select_sale_company.push(sale_company);
                                    }
                                    setAddData((addData) => ({
                                      ...addData,
                                      select_sale_company: _select_sale_company,
                                    }));
                                  }}
                                />
                                {sale_company.sale_company_name}
                              </Box>
                            );
                          },
                        )}
                        <FormHelperText
                          id="serch-name"
                          sx={{
                            textAlign: "right",
                            minHeight: "25px",
                            whiteSpace: "pre-line",
                          }}
                        >
                          {dataColumn.addMessage}
                        </FormHelperText>
                      </Box>
                    );
                  } else if (
                    dataColumn.addType === "closer_company" &&
                    addData.all_closer_company
                  ) {
                    return (
                      <Box key={"addBox" + i} data-testid={`add-modal-field-${dataColumn.key}`}>
                        <Box className="serch-label">{dataColumn.name}</Box>
                        {(addData.all_closer_company as any[]).map(
                          (closer_company: {
                            closer_company_id: string;
                            closer_company_name: string;
                          }) => {
                            const isSelf =
                              addData.current_sale_company_id !== undefined &&
                              String(closer_company.closer_company_id) ===
                                String(addData.current_sale_company_id);
                            return (
                              <Box
                                className="serch-label"
                                sx={{ marginRight: "25px" }}
                              >
                                {isSelf ? (
                                  <Box
                                    component="span"
                                    sx={{
                                      display: "inline-block",
                                      width: "42px",
                                      textAlign: "center",
                                    }}
                                  >
                                    -
                                  </Box>
                                ) : (
                                  <Checkbox
                                    checked={
                                      (
                                        addData.select_closer_company as any[]
                                      ).findIndex(
                                        (_closer_company) =>
                                          closer_company.closer_company_id ===
                                          _closer_company.closer_company_id,
                                      ) > -1
                                    }
                                    onClick={() => {
                                      let _select_closer_company = (
                                        addData.select_closer_company as any[]
                                      ).concat();
                                      if (
                                        (
                                          addData.select_closer_company as any[]
                                        ).findIndex(
                                          (_closer_company) =>
                                            closer_company.closer_company_id ===
                                            _closer_company.closer_company_id,
                                        ) > -1
                                      ) {
                                        _select_closer_company =
                                          _select_closer_company.filter(
                                            (_closer_company) =>
                                              closer_company.closer_company_id !==
                                              _closer_company.closer_company_id,
                                          );
                                      } else {
                                        _select_closer_company.push(
                                          closer_company,
                                        );
                                      }
                                      setAddData((addData) => ({
                                        ...addData,
                                        select_closer_company:
                                          _select_closer_company,
                                      }));
                                    }}
                                  />
                                )}
                                {closer_company.closer_company_name}
                              </Box>
                            );
                          },
                        )}
                        <FormHelperText
                          id="serch-name"
                          sx={{
                            textAlign: "right",
                            minHeight: "25px",
                            whiteSpace: "pre-line",
                          }}
                        >
                          {dataColumn.addMessage}
                        </FormHelperText>
                      </Box>
                    );
                  } else if (
                    dataColumn.addType === "collaborate_company" &&
                    addData.all_collaborate_company
                  ) {
                    return (
                      <Box key={"addBox" + i} data-testid={`add-modal-field-${dataColumn.key}`}>
                        <Box className="serch-label">{dataColumn.name}</Box>
                        {(addData.all_collaborate_company as any[]).map(
                          (collaborate_company: {
                            collaborate_company_id: string;
                            collaborate_company_name: string;
                          }) => {
                            return (
                              <Box
                                className="serch-label"
                                sx={{ marginRight: "25px" }}
                              >
                                <Checkbox
                                  checked={
                                    (
                                      addData.select_collaborate_company as any[]
                                    ).findIndex(
                                      (_collaborate_company) =>
                                        collaborate_company.collaborate_company_id ===
                                        _collaborate_company.collaborate_company_id,
                                    ) > -1
                                  }
                                  onClick={() => {
                                    let _select_collaborate_company = (
                                      addData.select_collaborate_company as any[]
                                    ).concat();
                                    if (
                                      (
                                        addData.select_collaborate_company as any[]
                                      ).findIndex(
                                        (_collaborate_company) =>
                                          collaborate_company.collaborate_company_id ===
                                          _collaborate_company.collaborate_company_id,
                                      ) > -1
                                    ) {
                                      _select_collaborate_company =
                                        _select_collaborate_company.filter(
                                          (_collaborate_company) =>
                                            collaborate_company.collaborate_company_id !==
                                            _collaborate_company.collaborate_company_id,
                                        );
                                    } else {
                                      _select_collaborate_company.push(
                                        collaborate_company,
                                      );
                                    }
                                    setAddData((addData) => ({
                                      ...addData,
                                      select_collaborate_company:
                                        _select_collaborate_company,
                                    }));
                                  }}
                                />
                                {collaborate_company.collaborate_company_name}
                              </Box>
                            );
                          },
                        )}
                        <FormHelperText
                          id="serch-name"
                          sx={{
                            textAlign: "right",
                            minHeight: "25px",
                            whiteSpace: "pre-line",
                          }}
                        >
                          {dataColumn.addMessage}
                        </FormHelperText>
                      </Box>
                    );
                  } else if (
                    dataColumn.addType === "closing_category" &&
                    addData.all_category
                  ) {
                    return (
                      <Box key={"addBox" + i} data-testid={`add-modal-field-${dataColumn.key}`}>
                        <Box className="serch-label">{dataColumn.name}</Box>
                        {(addData.all_category as any[]).map(
                          (category_inf: {
                            category_id: string;
                            category_name: string;
                          }) => {
                            return (
                              <Box
                                className="serch-label"
                                sx={{ marginRight: "25px" }}
                              >
                                <Checkbox
                                  checked={
                                    (
                                      addData.select_category as any[]
                                    ).findIndex(
                                      (_category_inf) =>
                                        category_inf.category_id ===
                                        _category_inf.category_id,
                                    ) > -1
                                  }
                                  onClick={() => {
                                    let _select_category = (
                                      addData.select_category as any[]
                                    ).concat();
                                    if (
                                      (
                                        addData.select_category as any[]
                                      ).findIndex(
                                        (_category_inf) =>
                                          category_inf.category_id ===
                                          _category_inf.category_id,
                                      ) > -1
                                    ) {
                                      _select_category =
                                        _select_category.filter(
                                          (_category_inf) =>
                                            category_inf.category_id !==
                                            _category_inf.category_id,
                                        );
                                    } else {
                                      _select_category.push(category_inf);
                                    }
                                    setAddData((addData) => ({
                                      ...addData,
                                      select_category: _select_category,
                                    }));
                                  }}
                                />
                                {category_inf.category_name}
                              </Box>
                            );
                          },
                        )}
                        <FormHelperText
                          id="serch-name"
                          sx={{
                            textAlign: "right",
                            minHeight: "25px",
                            whiteSpace: "pre-line",
                          }}
                        >
                          {dataColumn.addMessage}
                        </FormHelperText>
                      </Box>
                    );
                  } else if (
                    (dataColumn.addType === "incentive_service" ||
                      dataColumn.addType === "follow_call_service") &&
                    addData.all_service
                  ) {
                    return (
                      <Box key={"addBox" + i} data-testid={`add-modal-field-${dataColumn.key}`}>
                        <Box className="serch-label">{dataColumn.name}</Box>
                        {(addData.all_service as any[]).map(
                          (service: {
                            service_id: string;
                            service_name: string;
                          }) => {
                            const disabled =
                              (addData.select_service as any[]).findIndex(
                                (_service) =>
                                  service.service_name ===
                                  _service.service_name,
                              ) >
                                -1 !==
                              (addData.select_service as any[]).findIndex(
                                (_service) =>
                                  service.service_id === _service.service_id,
                              ) >
                                -1;
                            return (
                              <Box
                                className="serch-label"
                                sx={{ marginRight: "25px" }}
                              >
                                <Checkbox
                                  disabled={disabled}
                                  checked={
                                    (addData.select_service as any[]).findIndex(
                                      (_service) =>
                                        service.service_id ===
                                        _service.service_id,
                                    ) > -1
                                  }
                                  onClick={() => {
                                    let _select_service = (
                                      addData.select_service as any[]
                                    ).concat();
                                    if (
                                      (
                                        addData.select_service as any[]
                                      ).findIndex(
                                        (_service) =>
                                          service.service_id ===
                                          _service.service_id,
                                      ) > -1
                                    ) {
                                      _select_service = _select_service.filter(
                                        (_service) =>
                                          service.service_id !==
                                          _service.service_id,
                                      );
                                    } else {
                                      _select_service.push(service);
                                    }
                                    setAddData((addData) => ({
                                      ...addData,
                                      select_service: _select_service,
                                    }));
                                  }}
                                />
                                {service.service_name}
                              </Box>
                            );
                          },
                        )}
                        <FormHelperText
                          id="serch-name"
                          sx={{
                            textAlign: "right",
                            minHeight: "25px",
                            whiteSpace: "pre-line",
                          }}
                        >
                          {dataColumn.addMessage}
                        </FormHelperText>
                      </Box>
                    );
                  } else if (
                    dataColumn.addType === "follow_call_entry_sale_company" &&
                    addData.all_entry_sale_company
                  ) {
                    return (
                      <Box key={"addBox" + i} data-testid={`add-modal-field-${dataColumn.key}`}>
                        <Box className="serch-label">{dataColumn.name}</Box>
                        {(addData.all_entry_sale_company as any[]).map(
                          (entry_sale_company_inf: {
                            entry_sale_company_id: string;
                            entry_sale_company_name: string;
                          }) => {
                            return (
                              <Box
                                className="serch-label"
                                sx={{ marginRight: "25px" }}
                              >
                                <Checkbox
                                  checked={
                                    (
                                      addData.select_entry_sale_company as any[]
                                    ).findIndex(
                                      (_entry_sale_company_inf) =>
                                        entry_sale_company_inf.entry_sale_company_id ===
                                        _entry_sale_company_inf.entry_sale_company_id,
                                    ) > -1
                                  }
                                  onClick={() => {
                                    let _select_entry_sale_company = (
                                      addData.select_entry_sale_company as any[]
                                    ).concat();
                                    if (
                                      (
                                        addData.select_entry_sale_company as any[]
                                      ).findIndex(
                                        (_entry_sale_company_inf) =>
                                          entry_sale_company_inf.entry_sale_company_id ===
                                          _entry_sale_company_inf.entry_sale_company_id,
                                      ) > -1
                                    ) {
                                      _select_entry_sale_company =
                                        _select_entry_sale_company.filter(
                                          (_entry_sale_company_inf) =>
                                            entry_sale_company_inf.entry_sale_company_id !==
                                            _entry_sale_company_inf.entry_sale_company_id,
                                        );
                                    } else {
                                      _select_entry_sale_company.push(
                                        entry_sale_company_inf,
                                      );
                                    }
                                    setAddData((addData) => ({
                                      ...addData,
                                      select_entry_sale_company:
                                        _select_entry_sale_company,
                                    }));
                                  }}
                                />
                                {entry_sale_company_inf.entry_sale_company_name}
                              </Box>
                            );
                          },
                        )}
                        <FormHelperText
                          id="serch-name"
                          sx={{
                            textAlign: "right",
                            minHeight: "25px",
                            whiteSpace: "pre-line",
                          }}
                        >
                          {dataColumn.addMessage}
                        </FormHelperText>
                      </Box>
                    );
                  } else if (
                    dataColumn.addType === "login_sale_company" &&
                    addData.all_login_sale_company
                  ) {
                    return (
                      <Box key={"addBox" + i} data-testid={`add-modal-field-${dataColumn.key}`}>
                        <Box className="serch-label">{dataColumn.name}</Box>
                        {(addData.all_login_sale_company as any[]).map(
                          (login_sale_company_inf: {
                            login_sale_company_id: string;
                            login_sale_company_name: string;
                          }) => {
                            return (
                              <Box
                                className="serch-label"
                                sx={{ marginRight: "25px" }}
                              >
                                <Checkbox
                                  checked={
                                    (
                                      addData.select_login_sale_company as any[]
                                    ).findIndex(
                                      (_login_sale_company_inf) =>
                                        login_sale_company_inf.login_sale_company_id ===
                                        _login_sale_company_inf.login_sale_company_id,
                                    ) > -1
                                  }
                                  onClick={() => {
                                    let _select_login_sale_company = (
                                      addData.select_login_sale_company as any[]
                                    ).concat();
                                    if (
                                      (
                                        addData.select_login_sale_company as any[]
                                      ).findIndex(
                                        (_login_sale_company_inf) =>
                                          login_sale_company_inf.login_sale_company_id ===
                                          _login_sale_company_inf.login_sale_company_id,
                                      ) > -1
                                    ) {
                                      _select_login_sale_company =
                                        _select_login_sale_company.filter(
                                          (_login_sale_company_inf) =>
                                            login_sale_company_inf.login_sale_company_id !==
                                            _login_sale_company_inf.login_sale_company_id,
                                        );
                                    } else {
                                      _select_login_sale_company.push(
                                        login_sale_company_inf,
                                      );
                                    }
                                    setAddData((addData) => ({
                                      ...addData,
                                      select_login_sale_company:
                                        _select_login_sale_company,
                                    }));
                                  }}
                                />
                                {login_sale_company_inf.login_sale_company_name}
                              </Box>
                            );
                          },
                        )}
                        <FormHelperText
                          id="serch-name"
                          sx={{
                            textAlign: "right",
                            minHeight: "25px",
                            whiteSpace: "pre-line",
                          }}
                        >
                          {dataColumn.addMessage}
                        </FormHelperText>
                      </Box>
                    );
                  } else if (dataColumn.addType === "screen_column_select") {
                    const screenColumnSelectArray =
                      addData.screen_column_selects as {
                        id: number;
                        screen_column_select: string;
                      }[];
                    return (
                      <Box key={"addBox" + i} data-testid={`add-modal-field-${dataColumn.key}`}>
                        {screenColumnSelectArray.map((select, select_i) => {
                          return (
                            <Box
                              key={"addBoxPaymentMethod_" + i + "_" + select_i}
                            >
                              <SerchTextField
                                disable={false}
                                width="calc(100% - 80px)"
                                key={"addBoxPaymentMetho" + i}
                                label={"選択肢 - " + (select_i + 1)}
                                helperText={
                                  select_i + 1 ===
                                  screenColumnSelectArray.length
                                    ? dataColumn.addMessage
                                    : ""
                                }
                                value={select.screen_column_select as string}
                                setValue={(value) => {
                                  let _screenColumnSelectArray =
                                    screenColumnSelectArray.concat();
                                  _screenColumnSelectArray[
                                    select_i
                                  ].screen_column_select = value;
                                  setAddData((addData) => ({
                                    ...addData,
                                    screen_column_selects:
                                      _screenColumnSelectArray,
                                  }));
                                }}
                                dataKey={"screen_column_select"}
                                addData={addData}
                                multiline={false}
                              />
                              {screenColumnSelectArray.length > 1 ? (
                                <Button
                                  style={{
                                    height: "32px",
                                    width: "32px",
                                    marginLeft: "calc(100% - 75px)",
                                    marginTop: "-110px",
                                  }}
                                  onClick={(e) => {
                                    let _screenColumnSelectArray =
                                      screenColumnSelectArray.concat();
                                    _screenColumnSelectArray =
                                      _screenColumnSelectArray.filter(
                                        (_screen_column_select, _select_i) =>
                                          select_i !== _select_i,
                                      );
                                    setAddData((addData) => ({
                                      ...addData,
                                      screen_column_selects:
                                        _screenColumnSelectArray,
                                    }));
                                  }}
                                >
                                  <RemoveCircleOutlineIcon fontSize="medium" />
                                </Button>
                              ) : null}
                            </Box>
                          );
                        })}
                        <Box key={"addBoxPriceDataDelete"}>
                          <Button
                            style={{
                              fontSize: "20px",
                              marginTop: "-30px",
                              marginLeft: "calc(100% - 140px)",
                            }}
                            onClick={() => {
                              let _screenColumnSelectArray =
                                screenColumnSelectArray.concat();
                              _screenColumnSelectArray.push({
                                id: 0,
                                screen_column_select: "",
                              });
                              setAddData((addData) => ({
                                ...addData,
                                screen_column_selects: _screenColumnSelectArray,
                              }));
                            }}
                          >
                            <AddCircleOutlineIcon fontSize="medium" />
                          </Button>
                        </Box>
                      </Box>
                    );
                  } else if (dataColumn.addType === "site_pdf_path") {
                    return (
                      <Box key={"addBox" + i} data-testid={`add-modal-field-${dataColumn.key}`}>
                        <Box className="serch-label">{dataColumn.name}</Box>
                        <input
                          id="textFieldFiles"
                          type="file"
                          onChange={(
                            event_file: React.ChangeEvent<HTMLInputElement>,
                          ) => {
                            if (
                              event_file.target.files &&
                              event_file.target.files.length > 0
                            ) {
                              const file = event_file.target.files[0];
                              const updatedPostPictures = {
                                ...postFiles,
                                [dataColumn.key]: file,
                              };
                              setPostFiles(updatedPostPictures);
                            }
                          }}
                        />
                        <FormHelperText
                          id="serch-name"
                          sx={{
                            width: "calc(100% - 10px)",
                            textAlign: "right",
                            marginTop: "-8px",
                            height: "25px",
                            whiteSpace: "pre-line",
                          }}
                        >
                          {dataColumn.addMessage}
                        </FormHelperText>
                      </Box>
                    );
                  }
                }
              })}
            </Box>
          </Paper>
          <Box style={{ display: windowWidth > 385 ? "flex" : undefined }}>
            <Box
              style={{
                marginTop: "10px",
                height: "40px",
                width:
                  windowWidth > 385 ? "calc(50% - 5px)" : "calc(100% - 10px)",
                marginLeft: windowWidth > 385 ? undefined : "5px",
              }}
            >
              <Button
                disabled={!onAddButton}
                style={{
                  height: "40px",
                  width: "100%",
                  textTransform: "none",
                }}
                variant="contained"
                data-testid="add-modal-save-button"
                onClick={postAddData}
              >
                <Box className="m-plus-rounded-1c-regular">新規登録</Box>
                <AddCircleOutlineIcon
                  sx={{ marginLeft: "6px", color: "white" }}
                  fontSize="medium"
                />
              </Button>
            </Box>
            <Box
              style={{
                marginTop: "10px",
                height: "40px",
                width:
                  windowWidth > 385 ? "calc(50% - 5px)" : "calc(100% - 10px)",
                marginLeft: windowWidth > 385 ? "10px" : "5px",
              }}
            >
              <Button
                variant="contained"
                style={{
                  height: "40px",
                  width: "100%",
                  textTransform: "none",
                }}
                data-testid="add-modal-cancel-button"
                onClick={swCloseModal}
              >
                <Box className="m-plus-rounded-1c-regular">閉じる</Box>
              </Button>
            </Box>
          </Box>
        </Typography>
      </Box>
    </Modal>
  );
}
